import { memo } from "react";
import Chip from "@mui/material/Chip";
import type { FormInputStatusProps } from "./types";
import { FieldStatus, useConfigContext } from "../providers";

const FormInputStatus = ({
    fieldsStatuses
}: FormInputStatusProps) => {
    const config = useConfigContext();

    const getProps = () => (
        config.fieldStatusStyleMap.get(fieldsStatuses as FieldStatus) ??
        config.fieldStatusStyleMap.get(config.FieldStatusAwaitingReview)
    );

    return (
        <Chip
            {...getProps()}
            variant='soft'
            size='small'
        />
    );
};

export default memo(FormInputStatus);
